export function mailTalkListGet(pic, page, callback) {
	return {
    type: 'MAIL_TALK_LIST_GET',
		payload: {
			pic: pic,
			page: page,
		},
		callback: callback,
	}
}



export function mailSendCheck(pic, callback) {
	return {
    type: 'MAIL_SEND_CHECK',
		payload: {
			pic: pic,
		},
		callback: callback,
	}
}

export function mailSendText(pic, category, text, callback) {
	return {
    type: 'MAIL_SEND_TEXT',
		payload: {
			pic: pic,
			category: category,
			text: text,
		},
		callback: callback,
	}
}

export function mailSendPhoto(pic, category, photoBase64, callback) {
	return {
    type: 'MAIL_SEND_PHOTO',
		payload: {
			pic: pic,
			category: category,
			photoBase64: photoBase64,
		},
		callback: callback,
	}
}

export function mailSendVoice(pic, category, wav, callback) {
	return {
    type: 'MAIL_SEND_VOICE',
		payload: {
			pic: pic,
			category: category,
			wav: wav,
		},
		callback: callback,
	}
}
